export function toDegree (y, x) {
  return Math.atan2(y, x) * (180 / Math.PI);
}


//////////////////
// WEBPACK FOOTER
// ./~/tiny-slider/src/helpers/toDegree.js
// module id = 868
// module chunks = 2